import React from 'react';

interface BulkActionsProps {
  selectedIds: string[];
  onUpdate: () => void;
  onMove: () => void;
  onDelete: () => void;
  onInventory: () => void;
  className?: string;
}

const BulkActions: React.FC<BulkActionsProps> = ({
  selectedIds,
  onUpdate,
  onMove,
  onDelete,
  onInventory,
  className = '',
}) => {
  if (selectedIds.length === 0) return null;

  return (
    <div className={`flex flex-wrap items-center gap-2 p-3 bg-gray-50 border border-gray-200 rounded-md ${className}`}>
      <span className="text-sm font-medium text-gray-700 mr-2">Actions en masse :</span>
      
      <button
        onClick={onUpdate}
        className="flex items-center gap-1 px-3 py-1.5 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 transition-colors"
      >
        <span>✏️</span>
        <span>Modifier</span>
      </button>
      
      <button
        onClick={onMove}
        className="flex items-center gap-1 px-3 py-1.5 text-sm font-medium text-white bg-purple-600 rounded-md hover:bg-purple-700 transition-colors"
      >
        <span>🚚</span>
        <span>Déplacer</span>
      </button>
      
      <button
        onClick={onInventory}
        className="flex items-center gap-1 px-3 py-1.5 text-sm font-medium text-white bg-green-600 rounded-md hover:bg-green-700 transition-colors"
      >
        <span>✅</span>
        <span>Inventorier</span>
      </button>
      
      <button
        onClick={onDelete}
        className="flex items-center gap-1 px-3 py-1.5 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700 transition-colors"
      >
        <span>🗑️</span>
        <span>Supprimer</span>
      </button>
    </div>
  );
};

export default BulkActions;
